import useOnMeasurementToolOrAnnotationSelected from './useOnMeasurementToolOrAnnotationSelected';

export default useOnMeasurementToolOrAnnotationSelected;